// Copyright (c) 2016 Deere & Company

import OpenMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import t from 'tcomb';

const OpenMaintenancePlans = t.list(OpenMaintenancePlan, 'OpenMaintenancePlan');

export const getDefaultState = () => new OpenMaintenancePlans([]);

export default OpenMaintenancePlans;



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/state/open-maintenance-plans.js